import React from 'react';
import './noteBubble.less';

export default function NoteBubble({note}) {
	return (
		<div className="note-bubble-wrapper">
			<div className="note-bubble">
		    	{note}
			</div>
			<svg width="11px" height="11px" viewBox="0 0 11 11">
			    <g>
			        <polygon fill="#FFFFFF" points="0.471496582 10.0780029 10.6782837 1 10.3485107 0.669555664 0.149353027 0.669555664 0.149353027 9.71337891"></polygon>
			        <path d="M0.458618164,10.0715942 L10.6782837,1" stroke="#0074B8"></path>
			    </g>
			</svg>
		</div>
	);
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/NoteBubble.js